export function getActiveClinicScope(clinicId: string | null | undefined): string[] {
  return clinicId ? [clinicId] : [];
}
